import styled from '@emotion/styled';
import type { SurveyLocation as SurveyLocationType } from '@hotjar/feedback/domain/Surveys/Survey/SurveyLocations';
import {
  isModal,
  isOffsite,
  isPopover,
} from '@hotjar/feedback/domain/Surveys/Survey/SurveyLocations';
import { tokens, Stack, OptionCard } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import surveyPopoverImg from './images/popover.svg';
import surveyFullScreenImg from './images/fullscreen.svg';
import surveyOffsiteImg from './images/offsite.svg';

const StyledStack = styled(Stack)``;

const StyledOptionCard = styled(OptionCard)`
  cursor: pointer;
  max-width: 180px;
  height: 180px;
  justify-content: flex-start;
  margin-bottom: 0;
  & > span:first-of-type {
    width: ${tokens.spacer.x8};
    height: ${tokens.spacer.x4pt5};
  }
`;

export interface SurveyLocationProps {
  location: SurveyLocationType;
  onChangeLocation: (value: SurveyLocationType) => void;
}

export function SurveyLocation(props: SurveyLocationProps): JSX.Element {
  const { t } = useTranslation('feedback');
  const { location, onChangeLocation } = props;

  return (
    <StyledStack spacing="x3">
      <StyledOptionCard
        name="survey_location"
        kind="single-select"
        title={t(`survey.display-type.popover`)}
        value="popover"
        onChange={() => onChangeLocation('popover')}
        isChecked={isPopover(location)}
        description="Ask questions at key moments in the user journey"
        illustration={surveyPopoverImg}
      />
      <StyledOptionCard
        name="survey_location"
        kind="single-select"
        title={t(`survey.display-type.full_screen`)}
        value="full_screen"
        onChange={() => onChangeLocation('full_screen')}
        isChecked={isModal(location)}
        description="Immerse people in a survey without leaving your site"
        illustration={surveyFullScreenImg}
      />
      <StyledOptionCard
        name="survey_location"
        kind="single-select"
        title={t(`survey.display-type.external_link`)}
        value="external_link"
        onChange={() => onChangeLocation('external_link')}
        isChecked={isOffsite(location)}
        description="Get a link to send through any channel you like"
        illustration={surveyOffsiteImg}
      />
    </StyledStack>
  );
}
